import { render, staticRenderFns } from "./SoftwareComponentEdit.vue?vue&type=template&id=c9febd04&scoped=true&"
import script from "./SoftwareComponentEdit.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentEdit.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./SoftwareComponentEdit.vue?vue&type=style&index=1&id=c9febd04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9febd04",
  null
  
)

export default component.exports